import { useFormatMessage } from '../../../../../intl/intl';

export function useHeaderLang() {
  const messageCategory = 'cargo';
  const messageHeaderActionsSubcategory = 'headerActions';

  const infoTitleText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.infoTitle`,
  });

  const infoTitleDescriptionText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.infoDescription`,
  });

  const bannerWhenIsDisabledP1Text = useFormatMessage({
    id: 'cargo.headerActions.banner.whenIsDisabled.part1',
  });

  const bannerWhenIsDisabledP2Text = useFormatMessage({
    id: 'cargo.headerActions.banner.whenIsDisabled.part2',
  });

  const requestRappiTenderoActionTitleText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.requestRappiTenderoTitle`,
  });

  const requestRappiTenderoActionDescriptionText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.requestRappiTenderoDescription`,
  });

  const cargoOrdersActionTitleText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.cargoOrdersTitle`,
  });

  const cargoOrdersActionDescriptionText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.cargoOrdersDescription`,
  });

  const howCargoWorksActionTitleText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.howCargoWorksTitle`,
  });

  const howCargoWorksActionDescriptionText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.howCargoWorksDescription`,
  });

  const dropDownActionsCloseText = useFormatMessage({
    id: `${messageCategory}.${messageHeaderActionsSubcategory}.dropDownActionsClose`,
  });

  return {
    infoTitleText,
    infoTitleDescriptionText,
    requestRappiTenderoActionTitleText,
    requestRappiTenderoActionDescriptionText,
    cargoOrdersActionTitleText,
    cargoOrdersActionDescriptionText,
    howCargoWorksActionTitleText,
    howCargoWorksActionDescriptionText,
    dropDownActionsCloseText,
    bannerWhenIsDisabledP1Text,
    bannerWhenIsDisabledP2Text,
  };
}
